import React from "react";
import PropTypes from "prop-types";
import CustomModal from "../CustomModal";
import CustomButton from "../CustomButton";

const InviteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  count,
  inviterName,
  loading,
  emailCount = 0,
  smsCount = 0,
}) => {
  const hasEmail = emailCount > 0;
  const hasSms = smsCount > 0;

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm Invites"
      maxWidth="480px"
    >
      <p>
        You are about to send <strong>{count}</strong> invite
        {count === 1 ? "" : "s"} from Workbrook
        {hasEmail && hasSms
          ? ` (${emailCount} email, ${smsCount} SMS)`
          : hasSms
            ? " via SMS"
            : " via email"}
        .
      </p>
      <p className="small text-muted">
        This is the final step. Confirm only if you are ready to notify these
        contacts.
      </p>
      {hasEmail && (
        <div
          style={{
            background: "#F8FAFC",
            borderRadius: 8,
            padding: 16,
            marginBottom: 16,
            fontSize: 14,
            color: "#334155",
          }}
        >
          <strong>Email preview</strong>
          <p className="mb-1 mt-2">
            Subject: {inviterName || "A Workbrook user"} invited you to Workbrook
          </p>
          <p className="mb-0">
            Body: {inviterName || "A friend"} invited you to join Workbrook — the
            referral marketplace where professionals connect talent to opportunity.
            [Join Workbrook]
          </p>
        </div>
      )}
      {hasSms && (
        <div
          style={{
            background: "#F8FAFC",
            borderRadius: 8,
            padding: 16,
            marginBottom: 16,
            fontSize: 14,
            color: "#334155",
          }}
        >
          <strong>SMS preview</strong>
          <p className="mb-0 mt-2">
            {inviterName || "A Workbrook user"} invited you to Workbrook. Join
            here: [signup link]
          </p>
        </div>
      )}
      <div className="d-flex justify-content-end">
        <CustomButton
          text="Cancel"
          backgroundColor="#fff"
          color="#64748B"
          borderColor="#CBD5E1"
          handleClick={onClose}
          additionalClass="mr-2"
        />
        <CustomButton
          text={loading ? "Sending..." : `Send ${count} Invite${count === 1 ? "" : "s"}`}
          backgroundColor="#3A6ED4"
          color="#fff"
          handleClick={onConfirm}
          disabled={loading}
        />
      </div>
    </CustomModal>
  );
};

InviteConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  inviterName: PropTypes.string,
  loading: PropTypes.bool,
  emailCount: PropTypes.number,
  smsCount: PropTypes.number,
};

export default InviteConfirmModal;
